import React, { Component } from 'react';
import { Form, Button, Modal, Icon } from 'semantic-ui-react';
import Select from "antd/es/select";
import './styles.scss';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import functionCommon from "../../core/common/function";
import TimePicker from 'antd/es/time-picker';
import 'antd/es/time-picker/style/index.css';
import moment from 'moment';
import {
    getAddNewProjectList
} from "../../core/actions/addNewProjectAction";
import {
    addWorklog,
    updateWorklog,
    deleteWorklog,
    clearSuccessCode
} from '../../core/actions/workingHourAction';
import _ from 'lodash';

class DetailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: '',
            paramList: {
                employeeId: "",
                projectId: "",
                date: ""
            },
            info: {
                pic: "",
                projectCode: "",
                projectName: "",
                period: "",
                date: ""
            },
            worklogData: {
                employeeId: '',
                projectId: '',
                projectCode: '',
                projectName: '',
                businessFrom: '',
                businessTo: '',
                normalTime: '',
                'overtime-1': '',
                'overtimeType-1': '',
                'overtime-2': '',
                'overtimeType-2': '',
                'overtime-3': '',
                'overtimeType-3': '',
                remark: '',
                site: '',
                shift: '',
                status: '',
                approverId: ''
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            approverList: [],
            errorCode: "",
            btnDisable: false
        }
        
    }
    componentWillMount() {
        this.searchData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const data = nextProps.addNewProjectReducer.dataAddNewProject.workLogList[0];
        const approver = nextProps.addNewProjectReducer.dataAddNewProject.approver;
        let date = this.state.paramList.date;
        date = moment(date).locale("en").format("DD - MMM - YYYY");
        let _worklog = {
            id: data.id,
            employeeId: data.employeeId,
            projectId: data.projectId,
            projectCode: data.projectCode,
            projectName: data.projectName,
            businessFrom: (data.businessFrom && data.businessFrom !== null) ? data.businessFrom : '',
            businessTo: (data.businessTo && data.businessTo !== null) ? data.businessTo : '',
            normalTime: (data.normalTime && data.normalTime !== null) ? data.normalTime : '',
            'overtime-1': (data.overtimeList && data.overtimeList[0] && data.overtimeList[0].overtimeHour !== null) ? data.overtimeList[0].overtimeHour : '',
            'overtimeType-1': (data.overtimeList && data.overtimeList[0] && data.overtimeList[0].overtimeType !== null) ? data.overtimeList[0].overtimeType : '',
            'overtime-2': (data.overtimeList && data.overtimeList[1] && data.overtimeList[1].overtimeHour !== null) ? data.overtimeList[1].overtimeHour : '',
            'overtimeType-2': (data.overtimeList && data.overtimeList[1] && data.overtimeList[1].overtimeType !== null) ? data.overtimeList[1].overtimeType : '',
            'overtime-3': (data.overtimeList && data.overtimeList[2] && data.overtimeList[2].overtimeHour !== null) ? data.overtimeList[2].overtimeHour : '',
            'overtimeType-3': (data.overtimeList && data.overtimeList[2] && data.overtimeList[2].overtimeType !== null) ? data.overtimeList[2].overtimeType : '',
            remark: (data.remark && data.remark !== null) ? data.remark : '',
            site: (data.site && data.site === "1") ? true : false,
            shift: (data.shift && data.shift !== null) ? data.shift : '',
            status: (data.status && data.status !== null) ? data.status : '',
            approverId: (data.approverId && data.approverId !== null) ? data.approverId : ''
        };

        this.setState({
            info: {
                pic: data.employeeCode + ' - ' + data.employeeName,
                projectCode: data.projectCode,
                projectName: data.projectName,
                period: moment(data.period).locale("en").format("MMM - YYYY"),
                date: date
            },
            worklogData: _worklog,
            approverList: approver
        })

        if (nextProps.workingHourReducer.successCode) {
            this.props.clearSuccessCode();
            this.props.handleClose();
        }

        if (nextProps.workingHourReducer.errorCode) {
            
            this.setState({
                errorCode: nextProps.workingHourReducer.errorCode
            });
            this.setState({ btnDisable: false });
            setTimeout(
                function () {
                    this.setState({ errorCode: "" });
                    nextProps.workingHourReducer.errorCode = "";
                }.bind(this),
                2000
            );
        }
    }

    async searchData(props) {
        await this.setState({
            paramList: props.param
        });
        
        return this.props.getAddNewProjectList(this.state.paramList);
    }

    handleClose = (evt) => {
        this.props.handleClose();
    }

    handleCancel = (evt) => {
        this.props.handleCancel();
    }

    // Handle change business time input
    changeBusinessTime = (name, value) => {
        this.setState(prevState => ({
            worklogData: {
                ...prevState.worklogData,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));
    }

    // Change value bussiness from  field
    setBusinessFrom = (time, timeString) => {
        this.changeBusinessTime("businessFrom", timeString);
        this.state.inputSubmit.formError['businessFrom'] = ''
    }

    // Change value bussiness to field
    setBusinessTo = (time, timeString) => {
        this.changeBusinessTime("businessTo", timeString);
        this.state.inputSubmit.formError['businessFrom'] = ''
    }

    // Handle on change input
    changeWorkLog = evt => {
        const name = evt.target.name;
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
        this.setState(prevState => ({
            worklogData: {
                ...prevState.worklogData,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));
    }

    // Call API up date worklog
    async updateWorklog(){        

        // Set param
        const id = this.state.worklogData.id;
        const employeeId = this.state.worklogData.employeeId;
        const projectId = this.state.worklogData.projectId;
        const normalTime = (this.state.worklogData.normalTime) 
                            ? Number(this.state.worklogData.normalTime.replace(',','.')).toFixed(2) : '';
        const ot1 = (this.state.worklogData['overtime-1']) && (functionCommon.isDecimal(this.state.worklogData['overtime-1']))
                    ? Number(this.state.worklogData['overtime-1'].replace(',','.')).toFixed(2) : this.state.worklogData['overtime-1'].replace(',','.');
        const otType1 = this.state.worklogData['overtimeType-1'];
        const ot2 = (this.state.worklogData['overtime-2']) && (functionCommon.isDecimal(this.state.worklogData['overtime-2']))
                    ? Number(this.state.worklogData['overtime-2'].replace(',','.')).toFixed(2) : this.state.worklogData['overtime-2'].replace(',','.');
        const otType2 = this.state.worklogData['overtimeType-2'];
        const ot3 = (this.state.worklogData['overtime-3']) && (functionCommon.isDecimal(this.state.worklogData['overtime-3']))
                    ? Number(this.state.worklogData['overtime-3'].replace(',','.')).toFixed(2) : this.state.worklogData['overtime-3'].replace(',','.');
        const otType3 = this.state.worklogData['overtimeType-3'];
        const date = this.state.paramList.date;
        const remark = this.state.worklogData.remark;
        const businessFrom = this.state.worklogData.businessFrom 
                            ? moment(this.state.worklogData.businessFrom, "HHmm").format("HH-mm") : "";
        const businessTo = this.state.worklogData.businessTo 
                            ? moment(this.state.worklogData.businessTo, "HHmm").format("HH-mm") : "";
        const site = this.state.worklogData.site === true ? 1 : 0;
        const shift = this.state.worklogData.shift;
        const approverId = this.state.worklogData.approverId;
        const overtimeList = [(ot1 !== '') ? otType1 + '-' + ot1 : '', 
                        (ot2 !== '') ? otType2 + '-' + ot2 : '', 
                        (ot3 !== '') ? otType3 + '-' + ot3 : '']
        const status = this.state.worklogData.status;                

        if (id) {
            if (!this.checkValidateUpdate()) return;            
            this.setState({ btnDisable: true });
            if (Number(normalTime) === 0) {
                this.props.deleteWorklog({id: id});
            } else {
                this.props.updateWorklog({
                    id: id,
                    employeeId: employeeId,
                    projectId: projectId,
                    normalTime: normalTime,
                    date: date,
                    remark: remark,
                    businessFrom: businessFrom,
                    businessTo: businessTo,
                    site: site,
                    shift: shift,
                    status: status,
                    approverId: approverId,
                    overtimeList: overtimeList.filter(Boolean).join(',')
                });
            }
        } else {
            if (!this.checkValidate()) return;            
            this.setState({ btnDisable: true });
            this.props.addWorklog({
                employeeId: employeeId,
                projectId: projectId,
                normalTime: normalTime,
                date: date,
                remark: remark,
                businessFrom: businessFrom,
                businessTo: businessTo,
                site: site,
                shift: shift,
                status: status,
                approverId: approverId,
                overtimeList: overtimeList.filter(Boolean).join(',')
            });
        }
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};
        const { worklogData } = this.state;
        
        (worklogData.normalTime === '') ? _formError['normalTime'] = 'message.400' : _formError['normalTime'] = '';

        if (worklogData.normalTime !== '') {
            if (isNaN(worklogData.normalTime.replace(',','.')) || !functionCommon.validateDecimal(worklogData.normalTime)) {
                _formError['normalTime'] = 'message.400';
            } else if (parseFloat(worklogData.normalTime.replace(',','.')) <= 0) {
                _formError['normalTime'] = 'message.407';
            }
        }

        for (let i = 1; i <= 3; i++) {    
            if (worklogData['overtime-'+ i] !== '') {
                if (isNaN(worklogData['overtime-'+ i].replace(',','.')) || !functionCommon.validateDecimal(worklogData['overtime-'+ i])) {
                    _formError['overtime-'+ i] = 'message.404';
                } else if (parseFloat(worklogData['overtime-'+i].replace(',','.')) <= 0) {
                    _formError['overtime-'+ i] = 'message.408';
                }
            }
        }       

        for (let i = 1; i <= 3; i++) {  
            if ((worklogData['overtime-'+ i] !== '')
                && (worklogData.normalTime !== '')
                && functionCommon.validateDecimal(worklogData['overtime-'+ i])
                && functionCommon.validateDecimal(worklogData.normalTime)) {
                if (parseFloat(worklogData.normalTime.replace(',','.')) > 0 && parseFloat(worklogData['overtime-'+ i].replace(',','.')) > 0) {
                    if (parseFloat(worklogData['overtime-'+ i].replace(',','.')) 
                        > parseFloat(worklogData.normalTime.replace(',','.'))) {
                        _formError['overtime-'+ i] = 'message.401';
                    }
                }
            }
        }
        
        let totalOT = 0;
        for (let i = 1; i <= 3; i++) {
            totalOT += Number(worklogData['overtime-'+i].replace(',','.'));
        }

        if (parseFloat(worklogData.normalTime.replace(',','.')) > 0 && totalOT > parseFloat(worklogData.normalTime.replace(',','.'))) {
            if ((Number(worklogData['overtime-1'].replace(',','.')) > 0) && (worklogData['overtime-2'] === '') && (worklogData['overtime-3'] === '')) {
                _formError['normalTime'] = '';
            } else if ((Number(worklogData['overtime-2'].replace(',','.')) > 0) && (worklogData['overtime-1'] === '') && (worklogData['overtime-3'] === '')) {
                _formError['normalTime'] = ''; 
            } else if ((Number(worklogData['overtime-3'].replace(',','.')) > 0) && (worklogData['overtime-1'] === '') && (worklogData['overtime-2'] === '')) {
                _formError['normalTime'] = '';
            } else {
                _formError['normalTime'] = 'message.410';
            }
        }

        for (let i = 1; i <= 3; i++) {  
            if ((worklogData['overtime-'+i] !== '') && (worklogData['overtimeType-'+i] === '')) {
                _formError['overtimeType-'+i] = 'message.403';
            } else if ((worklogData['overtime-'+i] === '') && (worklogData['overtimeType-'+i] !== '')) {
                _formError['overtime-'+ i] = 'message.404';
            }
        }

        if ((worklogData.businessFrom !== '') && (worklogData.businessTo === '')) {
            _formError['businessFrom'] = 'message.406';
        } else if ((worklogData.businessFrom === '') && (worklogData.businessTo !== '')) {
            _formError['businessFrom'] = 'message.405';
        } else if ((worklogData.businessFrom !== '') && (worklogData.businessTo !== '')) {
            if (worklogData.businessTo.replace(":","") <= worklogData.businessFrom.replace(":","")) {
                _formError['businessFrom'] = 'message.402';
            } else {
                _formError['businessFrom'] = '';
            }
        }      

        if (parseFloat(worklogData.normalTime.replace(',','.')) <= 0) {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((parseFloat(worklogData['overtime-1'].replace(',','.')) <= 0) 
            || (parseFloat(worklogData['overtime-2'].replace(',','.')) <= 0) 
            || (parseFloat(worklogData['overtime-3'].replace(',','.')) <= 0)) {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if (worklogData.projectId === '' || worklogData.normalTime === '') {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-1'] !== '' && worklogData['overtimeType-1'] === '')
            || (worklogData['overtime-1'] === '' && worklogData['overtimeType-1'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-1'] !== '' && worklogData.normalTime !== '')
            && (parseFloat(worklogData['overtime-1'].replace(',','.')) > parseFloat(worklogData.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-2'] !== '' && worklogData['overtimeType-2'] === '')
            || (worklogData['overtime-2'] === '' && worklogData['overtimeType-2'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-2'] !== '' && worklogData.normalTime !== '')
            && (parseFloat(worklogData['overtime-2'].replace(',','.')) > parseFloat(worklogData.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-3'] !== '' && worklogData['overtimeType-3'] === '')
            || (worklogData['overtime-3'] === '' && worklogData['overtimeType-3'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-3'] !== '' && worklogData.normalTime !== '')
            && (parseFloat(worklogData['overtime-3'].replace(',','.')) > parseFloat(worklogData.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if (parseFloat(worklogData.normalTime.replace(',','.')) > 0 && totalOT > parseFloat(worklogData.normalTime.replace(',','.'))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if (worklogData.normalTime !== '' && !functionCommon.validateDecimal(worklogData.normalTime)
            || worklogData['overtime-1'] !== '' && !functionCommon.validateDecimal(worklogData['overtime-1'])) {
            this.isNotValid(_formError);
        } else if (worklogData.normalTime !== '' && !functionCommon.validateDecimal(worklogData.normalTime)
            || worklogData['overtime-2'] !== '' && !functionCommon.validateDecimal(worklogData['overtime-2'])) {
            this.isNotValid(_formError);
        } else if (worklogData.normalTime !== '' && !functionCommon.validateDecimal(worklogData.normalTime)
            || worklogData['overtime-3'] !== '' && !functionCommon.validateDecimal(worklogData['overtime-3'])) {
            this.isNotValid(_formError);
        } else if ((worklogData.businessFrom !== '' && worklogData.businessTo === '')
            || (worklogData.businessFrom === '' && worklogData.businessTo !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData.businessFrom !== '' && worklogData.businessTo !== '')
            && (worklogData.businessTo.replace(":","") <= worklogData.businessFrom.replace(":",""))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        }
        return isValidate;
    }

    // Check validate form
    checkValidateUpdate = () => {
        let isValidate = false;
        let _formError = {};
        const { worklogData } = this.state;
        
        (worklogData.normalTime === '') ? _formError['normalTime'] = 'message.400' : _formError['normalTime'] = '';

        if (worklogData.normalTime !== '') {
            if (isNaN(worklogData.normalTime.replace(',','.')) || !functionCommon.validateDecimal(worklogData.normalTime)) {
                _formError['normalTime'] = 'message.400';
            } else if (parseFloat(worklogData.normalTime.replace(',','.')) < 0) {
                _formError['normalTime'] = 'message.407';
            }
        }

        for (let i = 1; i <= 3; i++) {    
            if (worklogData['overtime-'+ i] !== '') {
                if (isNaN(worklogData['overtime-'+ i].replace(',','.')) || !functionCommon.validateDecimal(worklogData['overtime-'+ i])) {
                    _formError['overtime-'+ i] = 'message.404';
                } else if (parseFloat(worklogData['overtime-'+i].replace(',','.')) <= 0) {
                    _formError['overtime-'+ i] = 'message.408';
                }
            }
        }       

        for (let i = 1; i <= 3; i++) {  
            if ((worklogData['overtime-'+ i] !== '')
                && (worklogData.normalTime !== '')
                && functionCommon.validateDecimal(worklogData['overtime-'+ i])
                && functionCommon.validateDecimal(worklogData.normalTime)) {
                if (parseFloat(worklogData.normalTime.replace(',','.')) >= 0 && parseFloat(worklogData['overtime-'+ i].replace(',','.')) > 0) {
                    if (parseFloat(worklogData['overtime-'+ i].replace(',','.')) 
                        > parseFloat(worklogData.normalTime.replace(',','.'))) {
                        _formError['overtime-'+ i] = 'message.401';
                    }
                }
            }
        }
        
        let totalOT = 0;
        for (let i = 1; i <= 3; i++) {
            totalOT += Number(worklogData['overtime-'+i].replace(',','.'));
        }

        if (parseFloat(worklogData.normalTime.replace(',','.')) >= 0 && totalOT > parseFloat(worklogData.normalTime.replace(',','.'))) {
            if ((Number(worklogData['overtime-1'].replace(',','.')) > 0) && (worklogData['overtime-2'] === '') && (worklogData['overtime-3'] === '')) {
                _formError['normalTime'] = '';
            } else if ((Number(worklogData['overtime-2'].replace(',','.')) > 0) && (worklogData['overtime-1'] === '') && (worklogData['overtime-3'] === '')) {
                _formError['normalTime'] = ''; 
            } else if ((Number(worklogData['overtime-3'].replace(',','.')) > 0) && (worklogData['overtime-1'] === '') && (worklogData['overtime-2'] === '')) {
                _formError['normalTime'] = '';
            } else {
                _formError['normalTime'] = 'message.410';
            }
        }

        for (let i = 1; i <= 3; i++) {  
            if ((worklogData['overtime-'+i] !== '') && (worklogData['overtimeType-'+i] === '')) {
                _formError['overtimeType-'+i] = 'message.403';
            } else if ((worklogData['overtime-'+i] === '') && (worklogData['overtimeType-'+i] !== '')) {
                _formError['overtime-'+ i] = 'message.404';
            }
        }

        if ((worklogData.businessFrom !== '') && (worklogData.businessTo === '')) {
            _formError['businessFrom'] = 'message.406';
        } else if ((worklogData.businessFrom === '') && (worklogData.businessTo !== '')) {
            _formError['businessFrom'] = 'message.405';
        } else if ((worklogData.businessFrom !== '') && (worklogData.businessTo !== '')) {
            if (worklogData.businessTo.replace(":","") <= worklogData.businessFrom.replace(":","")) {
                _formError['businessFrom'] = 'message.402';
            } else {
                _formError['businessFrom'] = '';
            }
        }      

        if (parseFloat(worklogData.normalTime.replace(',','.')) < 0) {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((parseFloat(worklogData['overtime-1'].replace(',','.')) <= 0) 
            || (parseFloat(worklogData['overtime-2'].replace(',','.')) <= 0) 
            || (parseFloat(worklogData['overtime-3'].replace(',','.')) <= 0)) {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if (worklogData.projectId === '' || worklogData.normalTime === '') {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-1'] !== '' && worklogData['overtimeType-1'] === '')
            || (worklogData['overtime-1'] === '' && worklogData['overtimeType-1'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-1'] !== '' && worklogData.normalTime !== '')
            && (parseFloat(worklogData['overtime-1'].replace(',','.')) > parseFloat(worklogData.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-2'] !== '' && worklogData['overtimeType-2'] === '')
            || (worklogData['overtime-2'] === '' && worklogData['overtimeType-2'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-2'] !== '' && worklogData.normalTime !== '')
            && (parseFloat(worklogData['overtime-2'].replace(',','.')) > parseFloat(worklogData.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-3'] !== '' && worklogData['overtimeType-3'] === '')
            || (worklogData['overtime-3'] === '' && worklogData['overtimeType-3'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData['overtime-3'] !== '' && worklogData.normalTime !== '')
            && (parseFloat(worklogData['overtime-3'].replace(',','.')) > parseFloat(worklogData.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if (parseFloat(worklogData.normalTime.replace(',','.')) >= 0 && totalOT > parseFloat(worklogData.normalTime.replace(',','.'))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if (worklogData.normalTime !== '' && !functionCommon.validateDecimal(worklogData.normalTime)
            || worklogData['overtime-1'] !== '' && !functionCommon.validateDecimal(worklogData['overtime-1'])) {
            this.isNotValid(_formError);
        } else if (worklogData.normalTime !== '' && !functionCommon.validateDecimal(worklogData.normalTime)
            || worklogData['overtime-2'] !== '' && !functionCommon.validateDecimal(worklogData['overtime-2'])) {
            this.isNotValid(_formError);
        } else if (worklogData.normalTime !== '' && !functionCommon.validateDecimal(worklogData.normalTime)
            || worklogData['overtime-3'] !== '' && !functionCommon.validateDecimal(worklogData['overtime-3'])) {
            this.isNotValid(_formError);
        } else if ((worklogData.businessFrom !== '' && worklogData.businessTo === '')
            || (worklogData.businessFrom === '' && worklogData.businessTo !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklogData.businessFrom !== '' && worklogData.businessTo !== '')
            && (worklogData.businessTo.replace(":","") <= worklogData.businessFrom.replace(":",""))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        }
        return isValidate;
    }

    isNotValid = (_formError) => {
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: _formError
            }
        }));
    }

    fixDecimal = (val) => {
        return (functionCommon.isDecimal(val)) 
        ? Number(parseFloat(val).toFixed(2)) 
        : val
    }

    onChangeApprover = (value ) => {
        this.changeAutoComplete({_name: "approverId", _value: value});
    }

    // Handle on change autoComplete
    changeAutoComplete = evt => {
        const name = evt._name;
        const value = evt._value;
        this.setState(prevState => ({
            worklogData: {
                ...prevState.worklogData,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ""
                }
            }
        }));
    }

    // Render form update Worklog
    updateForm = () => {
        const { t, size, open, data } = this.props;
        const { info, worklogData, approverList, errorCode } = this.state;
        const _dataApprover = _.map(approverList, (state, index) => ({
            key: "employee-" + index,
            text: state['employeeName'],
            value: state['id'],
        }));
        const { Option } = Select;
        const overtimeTypeOps = [
            {
                value: '0',
                text: t('overtimeType.0')
            },
            {
                value: '6',
                text: t('overtimeType.6')
            },
            {
                value: '3',
                text: t('overtimeType.3')
            },
            {
                value: '1',
                text: t('overtimeType.1')
            },
            {
                value: '2',
                text: t('overtimeType.2')
            },
            {
                value: '4',
                text: t('overtimeType.4')
            },
            {
                value: '5',
                text: t('overtimeType.5')
            },
            {
                value: '7',
                text: t('overtimeType.7')
            }
        ];
        const shiftOps = [
            {
                value: '0',
                text: t('shift.0')
            },
            {
                value: '1',
                text: t('shift.1')
            },
            {
                value: '2',
                text: t('shift.2')
            }
        ]
        return (
            <div>
                <Form className="modal-form ui form">
                    <Form.Group inline>
                        <label className="title-label">{t('labels.pic')}</label>
                        <label className="txt-info">{info.pic}</label>
                    </Form.Group>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.projectCode')}</label>
                        <label className="txt-info">{info.projectCode}</label>
                    </Form.Group>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.projectName')}</label>
                        <label className="txt-info">{info.projectName}</label>
                    </Form.Group>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.period')}</label>
                        <label className="txt-info">{info.period}</label>
                    </Form.Group>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.date')}</label>
                        <label className="txt-info">{info.date}</label>
                    </Form.Group>
                    <Form.Group inline className="form-required">
                        <label  className="title-label">{t('labels.workingHour')}</label>
                        <Form.Input
                            name="normalTime"
                            value={worklogData.normalTime}
                            onChange={this.changeWorkLog.bind(this)}
                            maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['normalTime'])}</div>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.overtimeType')} 1</label>
                        <select name="overtimeType-1"
                            value={worklogData['overtimeType-1']}
                            onChange={this.changeWorkLog.bind(this)}>
                            <option value="">&nbsp;</option>
                            {(overtimeTypeOps)
                                ? overtimeTypeOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['overtimeType-1'], {type: 1})}</div>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.overtime')} 1</label>
                        <Form.Input
                            name="overtime-1"
                            value={worklogData['overtime-1'] || ''}
                            onChange={this.changeWorkLog.bind(this)}
                            maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['overtime-1'], {type: 1})}</div>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.overtimeType')} 2</label>
                        <select name="overtimeType-2"
                            value={worklogData['overtimeType-2']}
                            onChange={this.changeWorkLog.bind(this)}>
                            <option value="">&nbsp;</option>
                            {(overtimeTypeOps)
                                ? overtimeTypeOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['overtimeType-2'], {type: 2})}</div>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.overtime')} 2</label>
                        <Form.Input
                             name="overtime-2"
                             value={worklogData['overtime-2'] || ''}
                             onChange={this.changeWorkLog.bind(this)}
                             maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['overtime-2'], {type: 2})}</div>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.overtimeType')} 3</label>
                        <select name="overtimeType-3"
                            value={worklogData['overtimeType-3']}
                            onChange={this.changeWorkLog.bind(this)}>
                            <option value="">&nbsp;</option>
                            {(overtimeTypeOps)
                                ? overtimeTypeOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['overtimeType-3'], {type: 3})}</div>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.overtime')} 3</label>
                        <Form.Input
                            name="overtime-3"
                            value={worklogData['overtime-3'] || ''}
                            onChange={this.changeWorkLog.bind(this)}
                            maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['overtime-3'], {type: 3})}</div>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.approver')}</label>
                        <Select
                            name="approverId"
                            onChange={this.onChangeApprover}
                            style={{ width: '100%', maxWidth: '65%' }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={parseInt(worklogData.approverId) || ''}
                        >
                            <Option value="" label="">&nbsp;</Option>
                            {(_dataApprover)
                                ? _dataApprover.map((item, index)=> 
                                    <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                                )
                                : ''
                            }
                        </Select>
                    </Form.Group>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.shift')}</label>
                        <select name="shift"
                            value={worklogData.shift}
                            onChange={this.changeWorkLog.bind(this)}
                            >
                            <option value="">&nbsp;</option>
                            {(shiftOps)
                                ? shiftOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    
                    <Form.Group inline className="time-input">
                        <label className="title-label">{t('labels.businessFrom')}</label>
                        <TimePicker 
                            className="business-from-input"
                            inputReadOnly={true} 
                            format="HH:mm"
                            onChange={this.setBusinessFrom}
                            value={(worklogData.businessFrom) ? moment(worklogData.businessFrom, "HH:mm"): null}
                            minuteStep={5}
                            placeholder={""}/>
                        <label className="bussiness-to-label">{t('labels.to')}</label>
                        <TimePicker 
                            inputReadOnly={true} 
                            format="HH:mm"
                            onChange={this.setBusinessTo}
                            value={(worklogData.businessTo) ? moment(worklogData.businessTo, "HH:mm"): null}
                            minuteStep={5}
                            placeholder={""}/>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.inputSubmit.formError['businessFrom'])}</div>
                    <Form.Group inline className="site-checkbox">
                        <label  className="title-label">{t('labels.site')}</label>
                        <input type="checkbox" name="site" className="invisible"
                            id="on-site"
                            value={worklogData.site}
                            checked={worklogData.site === true ? true : false}
                            onChange={this.changeWorkLog.bind(this)}
                                />
                            <label htmlFor="on-site" className="checkbox-label no-text">{t('labels.site')}</label>
                    </Form.Group>
                    <Form.Group inline>
                        <label  className="title-label">{t('labels.remark')}</label>
                        <textarea
                            name="remark"
                            value={worklogData.remark}
                            onChange={this.changeWorkLog.bind(this)}
                            rows="3"></textarea>
                    </Form.Group>
                </Form>
                {errorCode ? (
                    <div className="error-message">
                        {(errorCode == "010") ? t("message.019") : t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <div className="modal-group-button">
                    <Button
                        primary
                        onClick={() => this.updateWorklog()}
                        disabled={this.state.btnDisable}
                    >
                        <Icon name='save' />{t('button.save')}
                    </Button>
                    <Button
                        primary
                        onClick={() => this.handleCancel()}
                    >
                        <Icon name='cancel' />{t('button.cancel')}
                    </Button>
                </div>
            </div>
        )
    }

    render() {
        const { t, size, open, data } = this.props;
        return (
            <div>
                <Modal size={size} open={open} onClose={this.handleCancel}>
                    <Modal.Header className="modal-header">
                        <p>{t("navigation.inquiryData")} / {t("button.update")}</p>
                        <p className="modal-close" onClick={() => this.handleCancel()}>x</p>
                    </Modal.Header>
                    <Modal.Content>
                        {this.updateForm()}
                    </Modal.Content>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    getAddNewProjectList: opt => dispatch(getAddNewProjectList(opt)),
    updateWorklog: (opt) => dispatch(updateWorklog(opt)),
    addWorklog: (opt) => dispatch(addWorklog(opt)),
    deleteWorklog: (opt) => dispatch(deleteWorklog(opt)),
    clearSuccessCode: () => dispatch(clearSuccessCode())
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(DetailModal);
